export const messages = {
  zh: {
    acceptanceManage: {
      search: {
        title: '查询条件',
        acceptanceName: '联系人',
        acceptanceNamePlaceholder: '请输入联系人',
        tel: '联系电话',
        telPlaceholder: '请输入联系电话',
        acceptanceId: '验收单编号',
        acceptanceIdPlaceholder: '请输入验收单编号'
      },
      list: {
        title: '验收单管理'
      },
      table: {
        acceptanceId: '验收单编号',
        contact: '联系人',
        contactTel: '联系电话',
        status: '状态',
        createTime: '创建时间'
      },
      status: {
        all: '全部',
        pending: '待验收',
        processing: '验收中',
        completed: '已完成',
        rejected: '已驳回'
      },
      fetchError: '获取验收单列表失败'
    }
  },
  en: {
    acceptanceManage: {
      search: {
        title: 'Search Conditions',
        acceptanceName: 'Contact',
        acceptanceNamePlaceholder: 'Please enter contact name',
        tel: 'Contact Tel',
        telPlaceholder: 'Please enter contact tel',
        acceptanceId: 'Acceptance ID',
        acceptanceIdPlaceholder: 'Please enter acceptance ID'
      },
      list: {
        title: 'Acceptance Management'
      },
      table: {
        acceptanceId: 'Acceptance ID',
        contact: 'Contact',
        contactTel: 'Contact Tel',
        status: 'Status',
        createTime: 'Create Time'
      },
      status: {
        all: 'All',
        pending: 'Pending',
        processing: 'Processing',
        completed: 'Completed',
        rejected: 'Rejected'
      },
      fetchError: 'Failed to fetch acceptance list'
    }
  }
}
